import React, { useState } from "react";
import bg from "assets/bg.png";
import logo from "assets/logo.png";
import ok from "assets/ok.png";
import fail from "assets/fail.png";
import noanswer from "assets/noanswer.png";

function Status(props) {

  return (
    <div className="container statusContainer">
      <div className="columns">
          <div className="column">
            <div className={props.status && props.status !== null ? "statusBadge statusOk" : !props.status  && props.status != null ?  "statusBadge statusFail" : null}>
               <p><span>
                   {props.status && props.status !== null ? (<img src={ok} />) : !props.status  && props.status != null ? (<img src={fail} />) : null}
                  </span>{props.statusText}</p>
            </div>
          </div>
      </div>
    </div>
  );
}

export default Status;
